<template>
  <div>
    <b-row>
      <b-col class="d-flex justify-content-between pb-1 align-items-center">
        <h1 class="font-weight-bolder">
          {{ $t('productTags') }}
        </h1>
        <b-button
          :to="{ name: 'new-product-tag' }"
          variant="primary"
        >
          {{ $t('register', { type: $t('productTags') }) }}
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <product-tags-table />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BButton } from 'bootstrap-vue'
import { mapActions } from 'vuex'
import ProductTagsTable from '@/components/productTags/ProductTagsTable.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    ProductTagsTable,
  },
  mounted() {
    this.fetchProductTags({ by_active_status: null })
  },
  methods: {
    ...mapActions('productTags', ['fetchProductTags']),
  },
}
</script>

<style lang="scss" scoped></style>
